import React, { useEffect, useState } from 'react';
import { FaBell, FaTimes } from 'react-icons/fa';
import {
  dismissPushBanner,
  getPushBannerMessage,
  onPushPermissionGranted,
  refreshPushPermissionGranted,
  requestPushHowToModal,
  shouldShowPushBanner
} from '../services/pushPermissionReminders';
import './PushPermissionBanner.scss';

function PushPermissionBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const granted = await refreshPushPermissionGranted();
      if (!cancelled) {
        setVisible(shouldShowPushBanner(granted));
      }
    };

    check();
    const unsubscribe = onPushPermissionGranted(() => setVisible(false));

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="container">
      <div className="push-permission-banner" role="status">
        <button
          type="button"
          className="push-permission-banner__dismiss"
          aria-label="Dismiss notification reminder"
          onClick={() => {
            dismissPushBanner();
            setVisible(false);
          }}
        >
          <FaTimes />
        </button>
        <FaBell className="push-permission-banner__icon" aria-hidden="true" />
        <p className="push-permission-banner__text">
          {getPushBannerMessage()}
        </p>
        <button
          type="button"
          className="push-permission-banner__cta"
          onClick={requestPushHowToModal}
        >
          How to enable
        </button>
      </div>
    </div>
  );
}

export default PushPermissionBanner;
